import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery"; // Import useMediaQuery
import React from "react";
import ReactCompareImage from "react-compare-image";


const useStyles = makeStyles((theme) => ({
  megaContainer: {
    width: "100%",
    /* XXS breakpoint */
    [theme.breakpoints.down(theme.breakpoints.values.xs + 280)]: {
      padding: "0rem 0.5rem 1rem 0.5rem",
    },
    [theme.breakpoints.only("xs")]: {
      padding: "0rem 1.5rem 1rem 1.5rem",
    },
    [theme.breakpoints.only("sm")]: {
      padding: "0rem 3rem 1rem 3rem",
    },
    [theme.breakpoints.only("md")]: {
      padding: "0rem 4rem 1rem 4rem",
    },
    [theme.breakpoints.only("lg")]: {
      padding: "0rem 4rem 1rem 4rem",
    },
    /* XLG breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.lg + 48)]: {
      padding: "0rem 5rem 1rem 5rem",
    },
    /* Full HD breakpoint */
    [theme.breakpoints.up("xl")]: {
      padding: "0rem 23rem 0rem 23rem",
    },
    /* XXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 640)]: {
      padding: "0rem 36rem 5rem 36rem",
    },
    /* XXXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 1920)]: {
      padding: "0rem 72rem 5rem 72rem",
    },
    margin: "0rem 0rem 6rem 0rem",
    [theme.breakpoints.down("xs")]: {
      margin: "0rem 0rem 3rem 0rem",
    },
  },
  mainContainer: {
margin: "2rem 0rem 2rem 0rem",
    padding: "0rem 8rem 0rem 8rem",
    [theme.breakpoints.down("sm")]: {
      padding: "0rem 2rem 0rem 2rem",
    },
    [theme.breakpoints.down("xs")]: {
      padding: "0rem 1.5rem 0rem 1.5rem",
    },
    [theme.breakpoints.down("md")]: {
      padding: "0rem 2rem 0rem 2rem",
    },
  },
  heading: {
  width: "100%",
    color: "#693471",
    fontWeight: 600,
    fontSize: "2.125rem",
    lineHeight: "2.65rem",
    margin: "0rem 0rem 0.5rem 0rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.25rem",
      lineHeight: "2rem",
      padding: "0rem 0rem 0.5rem 0rem",

    },
    background: "-webkit-linear-gradient(180deg, #74378E 0%, #502761 100%)",
    "-webkit-background-clip": "text",
    "-webkit-text-fillColor": "transparent",
  },

}));

const before = "images/Slider/V1.jpg";
const after = "images/Slider/V0.jpg";

const BeforeAfterSlider = () => {
  const classes = useStyles();
   const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  return (
    <React.Fragment>
      <div className={classes.mainContainer}>
        <div>
          <Typography variant="h1" component="h1" className={classes.heading}>
            Slice View
          </Typography>
         <div
            style={{

              borderRadius: isMobile ? "24px" : "0px",
              overflow: "hidden", // Ensures the border radius is applied properly
            }}
          >
            <ReactCompareImage
              leftImage={after}
              rightImage={before}
              sliderPositionPercentage={0.7}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default BeforeAfterSlider;
